module.exports = __webpack_public_path__ + "static/media/TataMotors2019.78da229c.png";